import axios from '@/axios'

class OrderDataService {
  getAllOrders(page: number, perPage = 20, status = ''): Promise<any> {
    let url = `/orders/getAllOrders?page=${page}&per_page=${perPage}`;
    if (status && status !== '') {
      url += `&status=${encodeURIComponent(status)}`;
    }
    return axios.get(url);
  }
  getAllOrdersForUser(userId: string, page = 1): Promise<any> {
    return axios.get(`/orders/${userId}/getAll?page=${page}`);
  }
  getOrderById(id: any): Promise<any> {
    return axios.get(`/orders/${id}/get`);
  }
  getCompanyUpdateOrder(id: any): Promise<any> {
    return axios.get(`/orders/${id}/getCompanyUpdateOrder`);
  }
  getOrderStatuses(): Promise<any> {
    return axios.get('/orders/getOrderStatuses');
  }
  add(data: any): Promise<any> {
    return axios.post('/orders/add', data);
  }
  update(id: any, data: any): Promise<any> {
    return axios.put(`/orders/${id}/update`, data);
  }
  bulkUpdateStatus(orderIds: number[], status: number): Promise<any> {
    return axios.put('/orders/bulk-update-status', { order_ids: orderIds, status });
  }
  delete(id: any): Promise<any> {
    return axios.delete(`/orders/${id}/delete`);
  }
  searchOrders(searchTerm: string): Promise<any> {
    return axios.get(`/orders/search?query=${searchTerm}`);
  }
  getPaidOrdersProfit(filters?: { start_date?: string; end_date?: string }): Promise<any> {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    const qs = params.toString();
    return axios.get(`/orders/getPaidOrdersProfit${qs ? '?' + qs : ''}`);
  }
  getPaidOrdersPaginated(page: number, filters?: { start_date?: string; end_date?: string }): Promise<any> {
    const params = new URLSearchParams();
    params.append('page', String(page));
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    return axios.get(`/orders/getPaidOrdersPaginated?${params.toString()}`);
  }
}
export default new OrderDataService();